// extracted by mini-css-extract-plugin
export default {"optionsContainer":"Likert_optionsContainer__N5cZe","radioContainer":"Likert_radioContainer__tSNWT"};